/**
 * Usage:
 *
 * data-sw-material-selector=<productSpin>
 *
 */

var $ = require('./../sw-jquery');
var MaterialSelector = require('./../../lib/views/MaterialSelector.js');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-material-selector]').each(function() {
    var $el = $(this);

    require(['js/lib/models/ModelManager'], function(ModelManager) {
      var spin = $el.data('swMaterialSelector');
      var dimensionInstanceId = $el.data('swMaterialSelectorDimensionInstance');
      var materialSelectorShapejsViewerName = $el.data('swMaterialSelectorShapejsViewerName');

      var product = ModelManager.getProduct(spin);

      new MaterialSelector({
        el: $el,
        model: product,
        productDimensionInstanceId: dimensionInstanceId,
        shapeJsId: materialSelectorShapejsViewerName
      });
    });
  });

};
